import React from 'react'
import { Color } from '../../utils/constants'
import PageHeader from '../../partials/PageHeader'
import Background from '../../assets/backgrounds/resources.svg'
import MobileBackground from '../../assets/backgrounds/resources-mobile.svg'
import MainGrid from './components/MainGrid'

const Resources = () => {
    return (
        <>
            <PageHeader
                title='page.resources.title'
                description='page.resources.description'
                bgColor={Color.SAND}
                component={Background}
                mobileComponent={MobileBackground}
            />
            <div className='bg-white'>
                <MainGrid />
            </div>
        </>
    )
}

export default Resources
